import * as React from "react"
import {Box, Link} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";
import {formatDate} from "@ui-seeker/utils";

import { LabelCountry, LinkIconBlock } from "@components";
import { BACKEND_APIS } from "@constants";


export default function ShareOfSearchRetailerBlock({ retailer, country, date, section, keyword, pageURL, siteURL }) {
	return <Box>
		<LabelCountry
			country={country}
			label={retailer}
			url={siteURL}
		/>
		<Box sx={{ fontSize: 13, color: "text.disabled" }}>
			{ !!date && <Box>
				Date: {formatDate(date, {isString: true})}
			</Box> }
			{ !!section && <Box>
				{section} <IconSeeker icon="arrow-up-right-from-square" sx={{ color: 'primary.main' }} />
			</Box> }
		</Box>
	</Box>
}